import {Link, useParams} from 'react-router-dom';
import {UserCircle} from '@phosphor-icons/react';
import {useTenantContext} from '@/app/TenantContext';
import {TenantLogo} from './TenantLogo';
import {tenantPath} from '@/lib/tenant/resolve';

/** Шапка клиентских экранов: логотип и название слева, вход в кабинет справа, тонкая линия снизу. */
export function TenantHeader() {
  const {tenant} = useTenantContext();
  const {slug = ''} = useParams();

  return (
    <header className="app-header relative z-30 pt-safe">
      <div className="flex items-center gap-3 px-4 py-3">
        <Link to={tenantPath(slug)} className="flex min-w-0 items-center gap-3">
          <TenantLogo name={tenant.name} logoUrl={tenant.logoUrl} className="h-10 w-10 shrink-0 rounded-full" />
          <span className="truncate text-[17px] font-bold tracking-tight text-foreground">{tenant.name}</span>
        </Link>
        <span className="flex-1" />
        <Link to={tenantPath(slug, 'profile')} aria-label="Профиль" className="text-foreground/80">
          <UserCircle size={32} weight="light" />
        </Link>
      </div>
      <div className="mx-4 h-px bg-white/10" />
    </header>
  );
}
